/*
 * @Description: 说明
 * @version: 版本
 * @Author: 作者
 * @Date: 2020-07-27 17:29:39
 * @LastEditTime: 2024-11-04 13:45:40
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import regionOss from './regionOss'
import { AMAP_KEY, AMAP_SECRET } from '@/utils/constants'
import { fetchAllSubordinates } from '@/utils/subordinates'
import { querySalesmanInfo, normalizeBusinessType } from '@/utils/crm.user'
import dayjs from 'dayjs'
Vue.use(Vuex)

// 企微主体列表无认证/客户类型，用 queryUserInfoQW 补齐（noCancel 避免被并发同接口取消）
async function fetchUserInfoQW(userId, userIdStr) {
  if (!userId && !userIdStr) return null
  const http = window.$http
  if (!http) return null
  try {
    const res = await http.post(
      'queryUserInfoQW',
      { userId, userIdStr },
      { noCancel: true }
    )
    if (!res || res.code != 200) return null
    // 兼容 ret / data；取消残留时 ret 可能是空串
    const payload = res.ret || res.data
    if (!payload || typeof payload !== 'object') return null
    return payload
  } catch (e) {
    console.log(e)
    return null
  }
}

async function loadCertificationType(userId, userIdStr) {
  const ret = await fetchUserInfoQW(userId, userIdStr)
  if (ret && ret.certificationType != null && ret.certificationType !== '') {
    return ret.certificationType
  }
  return null
}

function isSameUser(a, b) {
  if (!a || !b) return false
  if (a.userId != null && a.userId !== '' && b.userId != null && b.userId !== '' && a.userId == b.userId) {
    return true
  }
  if (a.userIdStr && b.userIdStr && a.userIdStr == b.userIdStr) {
    return true
  }
  return false
}

const debug = import.meta.env.MODE !== 'production'


export default new Vuex.Store({
  state: {
    title: '粮巴巴',
    userList: [],// 用户信息主体列表
    userInfo: {},// 当前用户主体信息
    chatId: '',// 群id
    salesInfo: {},// 当前销售信息
    shareOfferList: [],// 分享的报价
    customerList: [],// 选中的指定顾客
    oilList: [],// 选中的油厂
    cronSearch: {},// 玉米报价条件,
    beanSearch: {},// 豆粕报价条件,
    weChatId: 'wxd641d5a31223ee3f',// 小程序appid
    salesmanList: [],// 选中的业务员
    helpSellerIds: [], // 辅助交易白名单
    transaction: [],  // 交易配置
    supplierInfo: {}, // 当前供应商信息
    entry: '',// 页面的入口环境 contact_profile:从联系人详情进入;single_chat_tools:	从单聊会话的工具栏进入;group_chat_tools:	从群聊会话的工具栏进入;chat_attachment:	从会话的聊天附件栏进入;single_kf_tools:	从微信客服的工具栏进入;normal:	除以上场景之外进入，例如工作台，聊天会话等
    curExternalContact: {},// 当前聊天客户的信息
    keepPages: [], // 缓存的页面
    appTabs: [
      { name: '基本信息', path: '/portrait', type: 'single_chat_tools' },
      { name: '报价', path: '/offers-shareList', type: 'single_chat_tools' },
      { name: '合同', path: '/contract', type: '' },
      { name: '提货', path: '/orders', type: '' },
      { name: '主体信息', path: '/portrait', type: 'group_chat_tools' },
    ], //
    amapKey: AMAP_KEY,
    amapSecret: AMAP_SECRET,
    teamUserList: [],//当前登录人员能看到的团队人员列表
    teamUserIdList: [],
    currentTimeType: 1,
    currentTimeDetail: {
      startTime: dayjs().format("YYYY-MM-DD 00:00:00"),
      endTime: dayjs().format("YYYY-MM-DD 23:59:59"),
    },
    whiteStoreList: [],
    staffInfo: {}

  },
  modules: {
    regionOss
  },
  actions: {
    // 设置页面标题
    setTitle({ commit }, title) {
      commit('setTitle', title)
    },
    // 设置用户信息（补齐 custorType、certificationType；两边能力合并，只打一次 QW）
    async setUserInfo({ commit, state, dispatch }, data) {
      const prev = state.userInfo || {}
      const next = { ...(data || {}) }
      const sameUser = isSameUser(next, prev)
      // 同主体时保留已补齐字段，避免主体列表回写把字段冲掉
      if (sameUser) {
        if (
          (prev.certificationType != null && prev.certificationType !== '') &&
          (next.certificationType == null || next.certificationType === '')
        ) {
          next.certificationType = prev.certificationType
        }
        if (
          (prev.custorType != null && prev.custorType !== '') &&
          (next.custorType == null || next.custorType === '')
        ) {
          next.custorType = prev.custorType
          if (prev.custorTypeName != null) next.custorTypeName = prev.custorTypeName
        }
      }
      commit('setUserInfo', next)
      const info = state.userInfo || {}
      if (!info.userId && !info.userIdStr) return
      const switched = !isSameUser(info, prev)
      // certificationType=0 是个人，属有效值
      const needCustorType =
        switched || info.custorType == null || info.custorType === ''
      const needCertificationType =
        info.certificationType == null || info.certificationType === ''
      if (needCustorType || needCertificationType) {
        await dispatch('fetchUserInfoQWExtras', {
          needCustorType,
          needCertificationType,
          expectUserId: info.userId,
          expectUserIdStr: info.userIdStr,
        })
      }
    },
    // 从 queryUserInfoQW 一次补齐客户类型 / 认证类型
    async fetchUserInfoQWExtras(
      { commit, state },
      { needCustorType, needCertificationType, expectUserId, expectUserIdStr } = {}
    ) {
      const expect = { userId: expectUserId, userIdStr: expectUserIdStr }
      if (!expect.userId && !expect.userIdStr) return
      try {
        const ret = await fetchUserInfoQW(expect.userId, expect.userIdStr)
        if (!ret || !state.userInfo) return
        // 请求返回前若已切换主体，丢弃本次结果
        if (!isSameUser(state.userInfo, expect)) return
        const patch = { ...state.userInfo }
        if (needCustorType) {
          // 接口可能是 custorType 或 userType
          const custorType =
            ret.custorType != null && ret.custorType !== ''
              ? ret.custorType
              : ret.userType
          if (custorType != null && custorType !== '') {
            patch.custorType = custorType
          }
          if (ret.custorTypeName != null && ret.custorTypeName !== '') {
            patch.custorTypeName = ret.custorTypeName
          }
        }
        if (needCertificationType && ret.certificationType != null && ret.certificationType !== '') {
          patch.certificationType = ret.certificationType
        }
        commit('setUserInfo', patch)
      } catch (e) {
        console.log(e)
      }
    },
    // 当前主体缺少认证类型时补拉（session 恢复 / baseConfig 已有主体时仍单独调用）
    async fetchUserCertificationType({ commit, state, dispatch }) {
      const info = state.userInfo || {}
      // 0 是个人，不能当缺失
      if (info.certificationType != null && info.certificationType !== '') return
      if (!info.userId && !info.userIdStr) return
      // 一并补 custorType，避免只拉认证类型
      await dispatch('fetchUserInfoQWExtras', {
        needCustorType: info.custorType == null || info.custorType === '',
        needCertificationType: true,
        expectUserId: info.userId,
        expectUserIdStr: info.userIdStr,
      })
    },
    // 设置用户主体列表
    setUserList({ commit }, data) {
      commit('setUserList', data);
    },
    // 设置群id
    setChatId({ commit }, data) {
      commit('setChatId', data);
    },
    // 设置当前销售信息
    setSalesInfo({ commit }, data) {
      commit('setSalesInfo', data);
    },
    // 设置分享的报价
    setShareOffer({ commit }, data) {
      commit('setShareOffer', data);
    },
    // 设置选中的指定顾客
    setCustomerList({ commit }, data) {
      commit('setCustomerList', data);
    },
    // 设置选中的油厂
    setOilList({ commit }, data) {
      commit('setOilList', data);
    },
    // 设置玉米报价条件
    setCronSearch({ commit }, data) {
      commit('setCronSearch', data);
    },
    //设置选中的业务员
    setSalesmanList({ commit }, data) {
      commit('setSalesmanList', data);
    },
    // 设置页面标题
    setHelpSellerIds({ commit }, data) {
      commit('setHelpSellerIds', data)
    },
    // 设置交易配置运输方式配置
    setTransaction({ commit }, data) {
      commit('setTransaction', data)
    },
    // 设置当前供应商信息
    setSupplierInfo({ commit }, data) {
      commit('setSupplierInfo', data)
    },
    // 设置页面的入口环境
    setEntry({ commit }, data) {
      commit('setEntry', data)
    },
    // 设置当前聊天客户的信息
    setCurExternalContact({ commit }, data) {
      commit('setCurExternalContact', data)
    },
    // 设置缓存页面
    setKeepPages({ commit }, data) {
      commit('setKeepPages', data)
    },
    // 移除缓存页面
    removeKeepPages({ commit }, data) {
      commit('removeKeepPages', data)
    },
    // 清空缓存页面
    clearKeepPages({ commit }) {
      commit('clearKeepPages')
    },
    async setTeamUserList({ commit, state }) {
      if (!state.teamUserList.length && state.salesInfo.userId) {
        // 不传 isDel：含离职员工，供日程/日报/合同/客户筛选等共用
        const { data } = await fetchAllSubordinates({
          qwUserId: state.salesInfo.userId,
        })
        const list = data || []
        let idList = list.map(item => {
          const n = Number(item.sysUserId)
          return Number.isNaN(n) ? item.sysUserId : n
        }).filter(id => id != null && id !== '')
        commit('setTeamUserIdList', idList)
        commit('setTeamUserList', list)
      }
    },
    setCurrentTimeData({ commit }, data) {
      commit('setCurrentTimeData', data)
    },
    async setWhiteStoreList({ commit, state }) {
      try {
        const { code, ret } = await $http.get("pushContractWhite");
        if (code == 200) {
          commit('setWhiteStoreList', ret)
        }
      } catch (error) { }
    },
    async setStaffInfo({ commit, state }) {
      const qwUserId = state.salesInfo && state.salesInfo.userId
      if (!qwUserId) return

      const staffPromise = $http.post("getStaffInfo", {
        yearMonth: dayjs().format("YYYY-MM"),
        qwUserId,
      }).catch((e) => {
        console.error('getStaffInfo error:', e)
        return null
      })
      // 与 getStaffInfo 解耦：任务大宗/鸡窝依赖此接口，不能因绩效人员信息失败而跳过
      const salesmanPromise = querySalesmanInfo({ qwUserId }).catch((e) => {
        console.error('querySalesmanInfo error:', e)
        return null
      })

      const [staffRes, salesmanInfo] = await Promise.all([staffPromise, salesmanPromise])
      const staff = (staffRes && staffRes.code == 200 && staffRes.data) ? { ...staffRes.data } : {}
      if (salesmanInfo) {
        staff.salesmanInfo = salesmanInfo
        const businessType = normalizeBusinessType(salesmanInfo.businessType)
        if (businessType) {
          staff.businessType = businessType
        }
        if (salesmanInfo.role) {
          staff.dingRole = salesmanInfo.role
        }
      }
      if ((staffRes && staffRes.code == 200) || salesmanInfo) {
        commit('setStaffInfo', { ...state.staffInfo, ...staff })
      }
    },
  },
  mutations: {
    setTitle(state, title = '粮巴巴') {
      state.title = title || '';
      window.document.title = title; // 设置
    },
    // 设置用户信息
    setUserInfo(state, data) {
      state.userInfo = data || {}
    },
    // 设置用户主体列表
    setUserList(state, data) {
      state.userList = data || {}
    },
    // 设置群id
    setChatId(state, data) {
      state.chatId = data || ''
    },
    // 设置设置当前销售信息
    setSalesInfo(state, data) {
      state.salesInfo = data || {}
    },
    // 设置分享的报价
    setShareOffer(state, data) {
      state.shareOfferList = data || {}
    },
    // 设置选中的指定顾客
    setCustomerList(state, data) {
      state.customerList = data || {}
    },
    // 设置选中的油厂
    setOilList(state, data) {
      state.oilList = data || {}
    },
    // 设置玉米报价条件
    setCronSearch(state, data) {
      state.cronSearch = data || {}
    },
    // 设置豆粕报价条件
    setBeanSearch(state, data) {
      state.beanSearch = data || {}
    },
    // 设置选中的业务员
    setSalesmanList(state, data) {
      state.salesmanList = data || {}
    },
    // 设备辅助交易白名单
    setHelpSellerIds(state, data) {
      state.helpSellerIds = data || {}
    },

    // 设置交易配置运输方式配置
    setTransaction(state, data) {
      state.transaction = data || {}
    },
    // 设置当前供应商信息
    setSupplierInfo(state, data) {
      state.supplierInfo = data
    },
    // 设置页面的入口环境
    setEntry(state, data) {
      state.entry = data;
    },
    // 设置当前聊天客户的信息
    setCurExternalContact(state, data) {
      state.curExternalContact = data
    },
    // 设置缓存页面
    setKeepPages(state, data) {
      let ind = state.keepPages.findIndex(el => el == data);
      if (ind == -1) {
        state.keepPages.push(data)
      }
    },
    // 移除缓存页面
    removeKeepPages(state, data) {
      let ind = state.keepPages.findIndex(el => el == data);
      if (ind > -1) {
        state.keepPages.splice(ind, 1)
      }
    },
    // 清空缓存页面
    clearKeepPages(state) {
      state.keepPages.splice(0)
    },
    setTeamUserList(state, data) {
      state.teamUserList = data
    },
    setTeamUserIdList(state, data) {
      state.teamUserIdList = data
    },
    setCurrentTimeData(state, data) {
      state.currentTimeType = data.currentTimeType
      state.currentTimeDetail = data.currentTimeDetail
    },
    setWhiteStoreList(state, data) {
      state.whiteStoreList = data
    },
    setStaffInfo(state, data) {
      console.log({data})
      state.staffInfo = data
    }
  },
  strict: debug,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return {
          title: val.title,
          userList: val.userList,
          userInfo: val.userInfo,
          chatId: val.chatId,
          salesInfo: val.salesInfo,
          shareOfferList: val.shareOfferList,
          customerList: val.customerList,
          oilList: val.oilList,
          cronSearch: val.cronSearch,
          beanSearch: val.beanSearch,
          salesmanList: val.salesmanList,
          transaction: val.transaction,
          supplierInfo: val.supplierInfo,
          entry: val.entry,
          curExternalContact: val.curExternalContact,
          keepPages: val.keepPages
        }
      }
    }),
    createPersistedState({
      storage: window.localStorage,
      reducer(val) {
        return {
          // tabbarList: val.tabbarList
          // userInfo: val.userInfo,
        }
      }
    })
  ]
})
